import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { getLinkByorganizationId, postRegisterLink, putRegisterLink } from 'src/store/organization/thunks';
import { Button, Drawer, Form, Input, Select, Space, Table, Tooltip } from 'antd';
import { RequiredMark } from 'antd/es/form/Form';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import validateMessages from 'src/globals/Inputs/validateMessages';
import style from './Tables.module.scss'
import { servicesURl, typesIdentification } from 'src/globals/Parameters/listParameters';
import { ColumnsType } from 'antd/es/table';
import { servicesLink } from 'src/store/organization/types';
import { EditOutlined, HddOutlined } from '@ant-design/icons';

interface LinkAnalyticsTableProps {
    postRegisterLink?: any;
    putRegisterLink?: any;
    getLinkByorganizationId?: any;
    showModal: boolean;
    onClose: () => void;
    organizationId?:string;
}





const TLinkAnalytics: React.FC<LinkAnalyticsTableProps> = (props: LinkAnalyticsTableProps) => {
    const [form] = Form.useForm();
    const [type, setType] = useState("");
    const [typeRegister, setTypeRegister] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    const [dataTable, setDataTable] = useState([]);
    const onRegister = async (values: any) => {
        const request = {
            id:values.id,
            url:values.url,
            service:values.service,
            organizationId:props.organizationId
        }
        if(typeRegister){
            await props.postRegisterLink(request);
        }else{
            await props.putRegisterLink(request);
        }
       
        const responseData = await props.getLinkByorganizationId(props.organizationId);
        setDataTable(responseData);
        form.resetFields();
        setTypeRegister(true);

    };
    const showModalUpdate = async (value: servicesLink) => {
        setTypeRegister(false);
        form.setFieldsValue({
            url:value.url,service:value.service,id:value.id         
        });
    }
    useEffect(() => {
        const fetchData = async () => {
            if (props.organizationId) {
                const responseData = await props.getLinkByorganizationId(props.organizationId);
                setDataTable(responseData);
                form.resetFields();
                setTypeRegister(true);
            }
        };
    
        fetchData();
    }, [props.organizationId]);
    const columns: ColumnsType<servicesLink> = [
        {
            title: 'URL',
            width: 250,
            dataIndex: 'url',
            key: 'url',
        },
        {
            title: 'Servicio',
            width: 250,
            dataIndex: 'service',
            key: 'service',
        },
        {
            title: '',
            key: 'operation',
            fixed: 'right',
            width: 60,

            render: (record: servicesLink) =>
                <Space size="middle">
                    <Tooltip placement="topRight" title={validateMessages.establishmentButton} >
                        <Button
                            type="text"
                            className={style["update-button"]}
                            onClick={() => showModalUpdate(record)}
                            icon={<EditOutlined />}
                        >

                        </Button>
                    </Tooltip>
                    
                </Space>,
        },
    ]
    return (
        <>
            <Drawer open={props.showModal} width={950} footer={null} onClose={props.onClose}>
                <Form
                    form={form}
                    
                    layout="vertical"
                    initialValues={{ requiredMarkValue: requiredMark }}
                    requiredMark={requiredMark}
                    onFinish={onRegister}

                    size={componentSize as SizeType}
                >
                    <Form.Item style={{display:"none"}} name="id">
                        <Input />
                    </Form.Item>
                    <Form.Item label="URL" name="url" rules={[{ required: true, message: validateMessages.emptyField },]}>
                        <Input size='large' placeholder="Ingresar URL" />
                    </Form.Item>
                    <Form.Item  label="Servicio" className={style["select-fe"]} name="service" rules={[{ required: true, message: validateMessages.emptyField }]}>
                        <Select
                            size='large'
                            style={{ width: "100%" }}
                            onChange={(type: string) => setType(type)}
                            value={type}
                            placeholder="Escoga el servicio"
                        >
                            {servicesURl.map((type) => (
                                <Option key={`type-option-${type}`} value={type.id}                                >
                                    {type.value}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <Form.Item  >
                        <Button
                            htmlType="submit"
                            type="primary"
                            className={style["create-button-user-select"]}
                        >
                            {typeRegister ? "Registrar":"Actualizar"}
                        </Button>
                    </Form.Item>
                </Form>
                <Table size="middle" columns={columns} dataSource={dataTable} scroll={{ x: 500 }} />

            </Drawer>

        </>
    );


};

const mapStateToProps = (state: AppState) => ({

});

export default connect(mapStateToProps, {
    postRegisterLink, putRegisterLink, getLinkByorganizationId
})(TLinkAnalytics);